// material-ui
import { Grid, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import { useTheme } from '@mui/material/styles';
import HoverSocialCard from '../../../ui-component/cards/HoverSocialCard';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

// ==============================|| SAMPLE PAGE ||============================== //

const Form1095B = () => {
    const theme = useTheme();
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} lg={3} sm={6} />
            <Grid item xs={12} lg={6} sm={6}>
                <h3>Choose from the options below on how you want to file the tax.</h3>
            </Grid>
            <Grid item xs={12} lg={3} sm={6} />
            <Grid item xs={12} lg={3} sm={6} />
            <Grid item xs={12} lg={3} sm={6}>
                <HoverSocialCard
                    primary="Add Business Details"
                    secondary="Manual Entry"
                    iconPrimary={KeyboardIcon}
                    color={theme.palette.orange.dark}
                />
            </Grid>
            <Grid item xs={12} lg={3} sm={6}>
                <HoverSocialCard
                    primary="Import Employer Details"
                    secondary="Bulk Upload"
                    iconPrimary={CloudUploadIcon}
                    color={theme.palette.secondary.dark}
                />
            </Grid>
            <Grid item xs={12} lg={3} sm={6} />
        </Grid>
    );
};

export default Form1095B;
